import { AppState } from 'src/ducks';

export const __REDUX_STATE_KEY__ = 'sidebar';
export const getReduxStateSlice = (state: AppState) => state.ui[__REDUX_STATE_KEY__];

export const getSidebarOpenState = (state: AppState) => getReduxStateSlice(state).open;
